module.exports = __webpack_public_path__ + "img/electric_enabled.e8c3a678.svg";